import { Component, OnInit, OnDestroy  } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { Szme042aRequest, Szme042aResponseDryrskInfDto } from 'sg-api';
import { UsedSzme042aService } from '../../services/used-szme042a.service'
import { Subject } from 'rxjs';
import { Szme042aResponse, ResponseCommon } from 'sg-api';

/**
 * 延滞利息照会コンポーネント
 * @export
 * @class Sgkd011dComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'app-overdue-interest-inquiry',
  templateUrl: './sgkd011d.component.html',
  styleUrls: ['./sgkd011d.component.scss']
})
export class Sgkd011dComponent implements OnInit,OnDestroy  {

  /** 前画面から渡された売掛金番号 */
  cdtmnyNoParent: string;
  /**延滞利息情報 */
  interestList: Array<Szme042aResponseDryrskInfDto>;
  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();
  /** 画面表示フラグ */
  displayFlg: boolean = false;

  /** 延滞利息照会結果 */
  response: Szme042aResponse;
  /** responseCommon */
  responseCommon: ResponseCommon;

/**
 * コンストラクタ
 * @param {ActivatedRoute} route
 * @param {UsedSzme042aService} usedSzme042aService
 * @memberof OverdueInterestInquiryComponent
 */
constructor(private route: ActivatedRoute, private usedSzme042aService: UsedSzme042aService) {
    //　親画面から渡された売掛金番号を取得
    this.cdtmnyNoParent = this.route.snapshot.paramMap.get("cdtmnyNo");
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  /**
   * 初期処理
   * @memberof OverdueInterestInquiryComponent
   */
  ngOnInit(): void {
    this.usedSzme042aService.contractorValueChanges
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((response) => {
        this.response = response;
        this.responseCommon = response.responseCommon
        this.interestList = response.dryrskRefInfDto.dryrskInfDto;
      });
    // 延滞利息情報を取得
    this.getOverdueInterestInfo();
  }

  /**
   * 延滞利息情報取得APIを呼び出す
   */
  getOverdueInterestInfo(): void {
    // 延滞利息情報取得API呼び出し
    let request: Szme042aRequest = {
      cdtmnyNo: this.cdtmnyNoParent
    };

    this.usedSzme042aService.searchOverdueInterest(request).subscribe(response => {
      this.displayFlg = true;
    });
  }
}
